import { isHarmonyThemeId, useThemeId } from '@office-start/theming-service';
import { useMemo } from 'react';
/**
 * Visuals uses 'Office' as the supported theme id for the default theme in several mapped
 * types to pick styles and background images. This prop is also passed and referenced in controls
 * all the way down to Protected gradients.
 *
 * $TODO: Resolve the supported theme in one place/hook in office-start (instead of OfficeHome)
 * Make mapped types strongly typed
 */
export var useVisualsThemeId = function () {
    var themeId = useThemeId();
    return useMemo(function () {
        if (!themeId) {
            return undefined;
        }
        return isHarmonyThemeId(themeId) ? 'Office' : themeId;
    }, [themeId]);
};
//# sourceMappingURL=useVisualsThemeId.js.map